import { Typography } from 'antd';
import type { Message } from '@entities/chat';
import { Markdown } from '@shared/ui/Markdown';
import { CitationPills } from './CitationPills';
import { MessageImages } from './MessageImages';

const { Text } = Typography;

interface Props {
  message: Message;
}

/**
 * Один пузырь сообщения. user — справа, тёмный фон. assistant — слева,
 * светлый. Под ассистентским — миниатюры картинок (если есть) и плашки
 * citations.
 */
export function MessageBubble({ message }: Props) {
  const isUser = message.role === 'user';
  const chunkIds = message.retrieved_chunk_ids ?? [];
  const images = message.images ?? [];

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        marginBottom: 12,
      }}
    >
      <div style={{ maxWidth: '75%' }}>
        <div
          className={isUser ? undefined : 'tc-md'}
          style={{
            padding: '10px 14px',
            borderRadius: 12,
            background: isUser ? '#1F2937' : '#F3F4F6',
            color: isUser ? '#FFFFFF' : '#1A1A1A',
            fontSize: 14,
            lineHeight: 1.5,
            whiteSpace: isUser ? 'pre-wrap' : 'normal',
            wordBreak: 'break-word',
          }}
        >
          {isUser ? message.content : <Markdown text={message.content} />}
        </div>

        {!isUser && images.length > 0 && <MessageImages images={images} />}
        {!isUser && chunkIds.length > 0 && <CitationPills chunkIds={chunkIds} />}

        <Text
          type="secondary"
          style={{
            fontSize: 11,
            marginTop: 4,
            display: 'block',
            textAlign: isUser ? 'right' : 'left',
          }}
        >
          {formatTime(message.created_at)}
        </Text>
      </div>
    </div>
  );
}

function formatTime(iso: string): string {
  // Бэк отдаёт created_at без часового пояса, но это UTC (now() в PostgreSQL
  // на сервере). Без «Z» браузер считал бы его местным временем (−3 часа).
  const hasZone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(iso);
  const date = new Date(hasZone ? iso : `${iso}Z`);
  return date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  });
}
